import { useQuery } from '@apollo/client';
import type { QueryHookOptions } from '@apollo/client';

import { sortAlphabetically } from 'ClusterDashboard/Settings/helpers';

import { ResourceGroupsQuery } from './queries';
import type { ResourceGroupsQueryVariables, ResourceGroupsResponse, ResourceGroup } from './queries';

export type UseRgInput = QueryHookOptions<ResourceGroupsResponse, ResourceGroupsQueryVariables> & {
  show?: (rgs?: ResourceGroup[]) => string[];
};

function showRg(rgs?: ResourceGroup[]): string[] {
  if (!rgs) {
    return [];
  }

  return rgs.map(rg => rg.resourceGroupName).sort(sortAlphabetically);
}

export default function useRg({ variables, show = showRg, query = ResourceGroupsQuery, ...rest }: UseRgInput) {
  const {
    data: { resourceGroups } = {},
    loading,
    refetch,
    error,
  } = useQuery(query, {
    notifyOnNetworkStatusChange: true,
    variables,
    ...rest,
  });

  return {
    resourceGroups: show(resourceGroups),
    loading,
    refetch,
    error,
  };
}
